<template lang="pug">
  .component-policy
    .inner-content(v-if="$is('listing')")
      .row
        .column.shrink
          dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
            FederationButtons(:item="item", @itemUpdated="$emit('itemUpdated')")

        .column
          .field F{{item.id}}
          .field {{item.name}}
        .column.shrink
          router-link(:to="{name:'federation-vehicles', params:{id:item.id}}" )
            i.fa.fa-angle-right.fa-3x.action

        //.column
          .field Policies: {{item.policies.length}}
          .field(v-if="!item.global") Drivers: {{item.drivers}}
          .field(v-else) Global group


</template>

<script>
  import CardN from '../structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import FederationButtons from '../structure/ui/actions/FederationButtons'

  export default {
    name: 'Federation',
    components: {FederationButtons, Dropdown, CardN},
    props: ['item', 'type']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Federation.vue?1db828a4